/** @module components/slide-indicator */
import baustein from "baustein";
import templateSlideIndicator from "templates/components/slide-indicators";

var SELECTOR_INDICATORS = ".slide-indicators__indicator";

/**
 * The slide indicator is a simple component that indicates which slide is displayed. You
 * can click on a node and it will emit a click event. The slide indicator never changes the
 * indicated slide itself, to prevent potential inconsistencies.
 * Generally you'll want to use it in a control component with a slide-control.
 * @constructor
 * @alias module:components/slide-indicators
 * @extends module:components/components
 */
export default baustein.register(
    "slide-indicators",
    /** @lends module:components/slide-indicators.prototype */
    {
        template: templateSlideIndicator,

        defaultOptions: {
            selectedIndex: 0,
            maxSlides: 1,
            alternativeActiveHighlight: false,
        },

        setupEvents: function(add) {
            add("click", SELECTOR_INDICATORS, this._onIndicatorClick);
        },

        init() {
            if (this.options.maxSlides < 0) {
                throw new Error("maxSlides must be at least 0");
            }
        },

        onInsert() {
            // need to make sure that after being inserted the component is rendered as
            // currently all usages of this component are done via a placeholder element
            this.render();
        },

        getInitialRenderContext() {
            var selectedIndex = this.options.selectedIndex;

            if (selectedIndex >= this.options.maxSlides) {
                selectedIndex = this.options.maxSlides - 1;
            }

            if (selectedIndex < 0) {
                selectedIndex = 0;
            }

            return {
                selectedIndex: selectedIndex,
                maxSlides: this.options.maxSlides,
                alternativeActiveHighlight: this.options.alternativeActiveHighlight,
                hidden: this.options.maxSlides <= 1,
            };
        },

        /**
         * Set the selected index on the component to highlight.
         * @param index
         */
        setSelectedIndex(index) {
            if (index >= this.options.maxSlides) {
                index = this.options.maxSlides - 1;
            }

            if (index < 0) {
                index = 0;
            }

            this.setRenderContext({
                selectedIndex: index,
            });
        },

        getSelectedIndex() {
            return this.getRenderContext().selectedIndex;
        },

        _onIndicatorClick(event) {
            var selectedIndex = parseInt(event.target.getAttribute("data-index"));
            this.emit("indicatorClick", { newIndex: selectedIndex });
            this.setSelectedIndex(selectedIndex);
        },
    }
);
